import * as React from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { DatePicker } from '@airbus/components-react';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
  headerFilterBox: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    height: '100%',
    width: '100%',
    padding: '10px 5px 5px 5px !important',
  },
});

export default function RenderHeaderDateFilterField(
  props: GridFilterInputValueProps & {
    headerFilterMenu: React.ReactNode;
    clearButton: React.ReactNode;
  },
) {
  const classes = useStyles();

  const { item, applyValue, headerFilterMenu, clearButton } = props;
  const [value, setValue] = useState(item.value);

  useEffect(() => {
    const checkClear = Boolean(clearButton);
    if (!checkClear) {
      setValue(value ?? null);
    }
  }, [clearButton]);
  
  const handleFilterChange = (newValue) => {
    setValue(newValue);
    applyValue({ ...item, value: dayjs(newValue).format('YYYY-MM-DD') });
  };

  return (
    <React.Fragment>
      {headerFilterMenu}
      <div className={classes.headerFilterBox}>
        <DatePicker
          value={value ? new Date(value) : null}
          inputProps={{ style: { height: '100%' } }}
          onChange={(val) => handleFilterChange(val)}
          dateFormat='dd/mm/yyyy'
          datePattern='[0-9]{2}/[0-9]{2}/[0-9]{4}'
        />
      </div>
      {clearButton}
    </React.Fragment>
  );
}
